export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: i18n.t('headers.order-detail-number'),
          sortable: false,
          value: "number"
        },
        {
          text: "Nro. Radicado",
          sortable: false,
          value: "numberCase"
        },
        {
          text: "Fecha de apertura",
          sortable: false,
          value: "shippingDate"
        },
        {
          text: "Fecha de cierre ",
          value: "closeCase",
          sortable: false
        },
        { text: "Estado", value: "statusOrder", sortable: false },

        { text: i18n.t('headers.patient-document'), value: "document", sortable: false },
        { text: "Nombre del paciente", value: "name", sortable: false },
        { text: i18n.t('headers.provider'), value: "providerId", sortable: false }
      ],
      itemsData: [
        {
          shippingDate: "2019-02-08",
          number: 10001,
          document: 123213123,
          name: "Pepito Perez",
          statusOrder: "Empacado",
          providerId: "Helpharma",
          closeCase: "2019-02-09",
          numberCase: "001"
        }
      ]
    };
  },
  props: {},
  watch: {},
  methods: {
    onRowClick(item) {
      this.$emit("row-click", item);
    }
  }
};
